// src/api/hotel.ts

export interface Hotel {
  id: number;
  name: string;
  facilities: string;
  description: string;
  price: string;
  location: string;
  image: string;
}

export const getHotels = async (): Promise<Hotel[]> => {
  try {
    const res = await fetch("https://www.dreamstriphub.com/api/hotel_api.php");
    if (!res.ok) throw new Error(`HTTP error ${res.status}`);

    const data = await res.json();

    // Map PascalCase → camelCase
    return data.map((h: any) => ({
      id: parseInt(h.Id, 10),
      name: h.Name,
      facilities: h.Facilities,
      description: h.Description,
      price: h.Price,
      location: h.Location,
      image: h.Image.startsWith("http")
        ? h.Image
        : `https://www.dreamstriphub.com${h.Image}`, // fix relative path
    }));
  } catch (error) {
    console.error("Error fetching hotels:", error);
    return [];
  }
};
